module.exports = __webpack_public_path__ + "img/1-no-filter.4270cd8.png";


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/assets/1-no-filter.png
// module id = f9Nr
// module chunks = 1